module.exports = __webpack_public_path__ + "img/showbill5.c08347a9.jpg";